export default {"src":"/_next/static/media/appstore.99b2cd44.svg","height":48,"width":144,"blurWidth":0,"blurHeight":0};